// Engelse teksten van de to-do's op het bord (zie todo.nl.ts).
export const todoEn = {
    title: 'To-do',
    from: 'from {name}',
    all: 'All to-dos ({count})',
    sheetTitle: "{name}'s to-dos",
    due: 'by {date}',
    empty: 'Nothing left to do',
    done: 'Done',
    everyone: 'All',
    filterOpen: 'Open',
    filterDone: 'Done',
    filterAll: 'All',
    doneSection: 'Done ({n})',
    doneBy: '{name} · {when}',
    forWho: 'for {name}',
    created: 'added on {date}',
    important: 'Important',
    add: 'Add to-do',
    noDescription: 'No details',
    emptyDone: 'Nothing done yet this week',
    assign: 'Assign to…',
    assignTitle: 'Assign to',
    assignSave: 'Assign',
    assigned: 'Assigned',
    assignFailed: 'Could not assign',
};
//# sourceMappingURL=todo.en.js.map